import { defineColumns } from '@juvare/platform-shared/features/storage';
export const userConsentEntityName = 'notifyUserConsent';
export const columns = defineColumns({
    phoneNumber: {
        type: 'string-required',
        index: 'unique',
    },
    status: {
        type: 'string-required',
        index: true,
    },
    message: {
        type: 'string-required',
    },
    timestamp: {
        type: 'number',
    },
    search: {
        type: 'full-text-search',
        language: 'english',
        index: true,
    },
});
